<template>
  <div>
    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-6" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push('/coupon')"
          icon="keyboard_backspace"
        />
      </div>
      <div class="col-6">
        <q-btn
          class="capitalize ctrl-button right q-ml-md"
          :color="readOnly ? 'grey-5' :'ctrl-turquoise'"
          :label="readOnly ? getString('action.edit') : getString('action.save')"
          @click="saveChanges()"
          :icon-right="readOnly ? 'edit' : 'save'"
        />
        <q-btn v-if="data.id"
          class="q-ml-md capitalize ctrl-button right"
          icon-right="delete"
          color="negative capitalize"
          :label="$store.state.stringsStore.strings.action.delete"
          align="right"
          @click="deletePromotion()"
        />
      </div>
    </div>

    <div class="row">

      <!-- Left -->
      <div v-if="loaded" class="col-md-6 col-sm-12 col-xs-12">
        <div class="row q-mb-md q-mr-md">
          <div class="full-width">
            <p class="card-title">{{getString('general')}}</p>

            <div class="card-block">
              <div class="row q-mb-sm">

                <div class="col-md-4 col-sm-12">
                  <q-input
                    class="q-mr-md"
                    color="primary"
                    :disable="readOnly"
                    v-model="data.code"
                    float-label="Code"/>
                </div>

                <div class="col-md-4 col-sm-6">
                  <q-select
                    class="q-mr-md"
                    color="primary"
                    v-model="data.type"
                    :disable="readOnly"
                    :options="typeOptions"
                    float-label="Type"/>
                </div>

                <div class="col-md-4 col-sm-6">
                  <q-input
                    :disable="data.type === 'sweepstake' || readOnly"
                    class="q-mr-md"
                    :max="data.type === 'discount_percent' ? 100 : null"
                    color="primary"
                    type="number"
                    v-model="data.value"
                    :float-label="getString('module.promotion.fields.data.value')"/>
                </div>

            </div>
              <div class="row q-mb-sm">

                <div class="col-md-12">
                  <q-input
                    class="q-mr-md"
                    color="primary"
                    :disable="readOnly"
                    v-model="data.message"
                    :float-label="getString('module.coupon.field.message')"/>
                </div>

                <div class="col-md-12">
                  <q-input
                    class="q-mr-md"
                    color="primary"
                    :disable="readOnly"
                    v-model="data.description"
                    :float-label="getString('module.coupon.field.description')"/>
                </div>

                </div>
            </div>
          </div>

          <div class="full-width q-mt-md" v-if="data.used.length">
            <p class="card-title">Usage</p>

            <div class="card-block">
              <q-list highlight>
                <q-item v-for="used in data.used" :key="used.id">
                  <q-item-main :label="used.firstname + ' ' + used.lastname" />
                  <q-item-side right>
                    {{ used.datetime | formatDateTime }}
                  </q-item-side>
                </q-item>
              </q-list>
            </div>
          </div>
        </div>
      </div>

      <!-- Right -->
      <div v-if="loaded" class="col-md-6 col-sm-12 col-xs-12">
        <div class="row q-mb-md">
          <div class="full-width">
            <p class="card-title">Details</p>

            <div class="card-block">
              <div class="row q-mb-sm">
                <div class="col-md-6">
                  <q-datetime
                    :disable="readOnly"
                    :max="data.valid.to"
                    class="q-mr-md"
                    :float-label="startDate"
                    v-model="data.valid.from" />
                </div>
                <div class="col-md-6">
                  <q-datetime
                    :disable="readOnly"
                    :min="data.valid.from"
                    :float-label="endDate"
                    v-model="data.valid.to"
                    clearable />
                </div>

              </div>
              <!-- Accounts -->
              <div class="row q-mb-sm">
                <div class="col-md-12">
                  <chips-autocomplete
                    :disable="readOnly"
                    @change="updateAccounts"
                    :error="false"
                    :errorLabel="$store.state.stringsStore.language === 'nl' ? 'Dit veld is verplicht' : 'This field is required'"
                    class="q-pb-md full-width"
                    :selection="data.accounts"
                    :name="'Accounts'"
                    :labelTerm="'name'"
                    :endpoint="'account'"
                    :resultLabel="'accounts'"
                  />
                </div>
              </div>
              <div class="row q-mb-sm">
                <div class="col-md-12">
                  <!-- Single use -->
                  <q-toggle
                    :disable="readOnly"
                    class="q-mt-md"
                    color="secondary"
                    v-model="data.single_use"
                  >
                    <span style="margin-left: 1em;">
                      {{ getString('module.coupon.field.single_use') }}
                    </span>
                  </q-toggle>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';
import saveChanges from '@/mixins/detailViews/saveChanges';

// Mixins
import getString from '@/helpers/GetStrings';
import errorHandler from '@/mixins/detailViews/errorHandler';
import ChipsAutocomplete from '@/components/ChipsAutocomplete.vue';

export default {
  components: {
    ChipsAutocomplete,
  },
  mixins: [
    saveChanges,
    errorHandler,
  ],
  data() {
    return {
      // Name of the module defined in user rights. eg. blog for blog.edit, blog.add etc..
      permission: 'coupon',
      // Where data is fetched from
      endpoint: 'coupon',
      // The object key from the response object
      responseData: {
        single: 'coupon',
        multiple: 'coupons',
      },
      // Used for navigation on the front-end (matching the router)
      module: 'coupon',

      loaded: false,
      readOnly: true,

      typeOptions: [
        { label: 'Euro', value: 'discount_euro' },
        { label: 'Sweepstake', value: 'sweepstake' },
        { label: 'Percent', value: 'discount_percent' },
      ],

      data: {
        used: [],
        code: '',
        message: '',
        description: '',
        valid: {
          from: Date.now(),
          to: null,
        },
        accounts: [],
        single_use: false,
      },
    };
  },

  filters: {
    formatDateTime(val) {
      return moment(val).format('YYYY-MM-DD HH:mm');
    },
  },

  methods: {
    getString,

    fetchCoupon() {
      this.axios.get(`coupon/${this.$route.params.id}`).then(async (res) => {
        this.data = res.data.coupon;
        this.loaded = true;
      });
    },

    deleteCoupon() {
      this.axios.delete(`coupon/${this.$route.params.id}`).then(() => {
        this.$router.push('/coupon');
      });
    },

    updateAccounts(newVal) {
      this.data.accounts = newVal;
    },

    requestParams() {
      const params = {
        code: this.data.code,
        type: this.data.type,
        description: this.data.description,
        single_use: this.data.single_use ? 1 : 0,
        message: this.data.message,
        valid_from: this.data.valid.from ? moment(this.data.valid.from).utc().format('YYYY-MM-DD') : null,
        valid_to: this.data.valid.to ? moment(this.data.valid.to).utc().format('YYYY-MM-DD') : null,
        account: this.data.accounts.map(a => a.id),
      };

      if (this.data.type !== 'sweepstake') {
        params.value = this.data.value;
      }

      return params;
    },
    usedByName(data) {
      return `${data.firstname} ${data.lastname}`;
    },
  },

  computed: {
    startDate() {
      return this.$store.state.stringsStore.language === 'nl' ? 'Geldig van' : 'Valid from';
    },

    endDate() {
      return this.$store.state.stringsStore.language === 'nl' ? 'Geldig tot' : 'Valid to';
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.fetchCoupon();
    } else {
      this.loaded = true;
      this.readOnly = false;
    }
  },

  watch: {
    'data.value': function () {
      if (this.data.type === 'discount_percent') {
        if (this.data.value > 100) {
          this.data.value = 100;
        }
      }
    },
  },
};
</script>

<style lang="stylus">
.card-block.rule-deleted
    background rgba(255, 255, 255, 0.5)
</style>
